export function remoteSource(props, val = null) {
    const { trans } = props;

    if(props.autocomplete.error) {
        return [{ text: `<span style="color: #de3226">${trans('errors.options')}</span>`, disabled: true, value: 'system_error'}];
    }

    return props.autocomplete.value;
}